export enum UnsubscribeTemplateNames {
    CASH_OUT = 'CASH_OUT',
    SAVINGS = 'SAVINGS',
    RATE_REDUCTION = 'RATE_REDUCTION',
    EQUITY_RATE_TERM_REFINANCE = 'EQUITY_RATE_TERM_REFINANCE',
    TRIGGER_LEADS = 'TRIGGER_LEADS',
    BIRTHDAY = 'BIRTHDAY',
    ANNIVERSARY = 'ANNIVERSARY',
    CLOSED_LOAN = 'CLOSED_LOAN',
    EPO = 'EPO',
    TBD = 'TBD'
}

export const UnsubscribeTemplateTitles = (): any => {
    let templateNames = {};
    templateNames[UnsubscribeTemplateNames.CASH_OUT] = 'Cash Out';
    templateNames[UnsubscribeTemplateNames.SAVINGS] = 'Savings';
    templateNames[UnsubscribeTemplateNames.RATE_REDUCTION] = 'Rate Reduction';
    templateNames[UnsubscribeTemplateNames.EQUITY_RATE_TERM_REFINANCE] = 'Equity Growth';
    templateNames[UnsubscribeTemplateNames.TRIGGER_LEADS] = 'Trigger Leads';
    templateNames[UnsubscribeTemplateNames.BIRTHDAY] = 'Birthday Touchpoint';
    templateNames[UnsubscribeTemplateNames.ANNIVERSARY] = 'Annual Loan Review';
    templateNames[UnsubscribeTemplateNames.CLOSED_LOAN] = 'Post-Closing Review';
    templateNames[UnsubscribeTemplateNames.EPO] = 'EPO Review';
    templateNames[UnsubscribeTemplateNames.TBD] = 'TBD Approval';
    return templateNames;
};

export class CustomerSubscriptionStatus {
    templateName: UnsubscribeTemplateNames;
    status: Boolean;
}
